import { HttpClient, AMCFundStatusUtil } from "_fil_local_addon/camc-cms-base/index";
import { FUND_API_SOURCES } from "_fil_local_addon/camc-cms-base/amc_fund_api.constant";

export class CAMCFundFOFHandler {
    static isfof = false;
    static fetchCompleted = false;

    static async fetchIsFOF() {
        if (this.fetchPromise) {
            return;
        }

        try {
            const httpClient = new HttpClient();
            const options = {
                errorHandler: () => {},
            };

            const fundData = await httpClient.get(
                `${FUND_API_SOURCES.FUND_SHARECLASS_SOURCE}${window.fundCode}`,
                options,
            );

            this.isfof = fundData?.data?.fundType?.[0]?.fundType === "FOF";
        } catch (error) {
            console.error("An error occurred in fetchIsFOF:", error);
            this.isfof = false;
        }
        this.fetchCompleted = true;
    }

    static async getIsFOF() {
        if (!this.fetchCompleted && window.fundCode) {
            await this.fetchIsFOF();
        }
        return this.isfof;
    }
}

const disableAnchorScroll = () => {
    // disable fund pages scrolling when opening a url with id tag
    if (window.fundCode && $("#body-container").hasClass("china-amc")) {
        const sanitizedHash = window.location.hash.substring(1).replace(/[^a-zA-Z0-9_\-]/g, "");
        // delete hash so the page won't scroll to it, use replaceState to avoid adding history entry
        history.replaceState("", document.title, window.location.pathname + window.location.search);

        $(document).ready(function () {
            if ($(`#${sanitizedHash}`).length && $(".fil-tabs").length) {
                $(`#${sanitizedHash}`).trigger("click");
                $("html, body").animate(
                    {
                        scrollTop: $(`#${sanitizedHash}`).offset().top,
                    },
                    1,
                    "swing",
                    function () {
                        history.replaceState(
                            "",
                            document.title,
                            window.location.pathname + window.location.search + "#" + sanitizedHash,
                        );
                    },
                );
            }
        });
    }
};

disableAnchorScroll();
